exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".home__home--1a8g0{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Source Sans Pro,sans-serif;background:#f2fafc}", ""]);

// exports
exports.locals = {
	"home": "home__home--1a8g0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":true,"config":{"path":"/var/www/prb-datafinder/client/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./app/components/home/home.scss
// module id = 590
// module chunks = 0